import maleConcierge from '@assets/Participation/male-concierge.png';
import femaleConcierge from '@assets/Participation/female-concierge.png';

export const popupImgSrcContent = {
  Male: maleConcierge,
  Female: femaleConcierge
};
